import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { MarketingConsentStatus } from "@redotech/redo-model/customer";
import { MarketingSuppressionReason } from "./suppression/marketing-suppression-zod-schema";

export const audienceMemberSchema = z.object({
  name: z.string(),
  customerId: zExt.objectId(),
  email: z.string().optional(),
  phoneNumber: z.string().optional(),
  emailSubscriptionStatus: createEnum(MarketingConsentStatus),
  emailSuppressionReasons: z.array(createEnum(MarketingSuppressionReason)),
  smsSubscriptionStatus: createEnum(MarketingConsentStatus),
  smsSuppressionReasons: z.array(createEnum(MarketingSuppressionReason)),
});

export type AudienceMember = z.infer<typeof audienceMemberSchema>;
